"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectNodeKnowledge = void 0;
var ConnectNodeRemovedImpulse_1 = require("./ConnectNodeRemovedImpulse");
var ConnectNodeUnsetImpulse_1 = require("./ConnectNodeUnsetImpulse");
var ConnectNodeAppendedImpulse_1 = require("./ConnectNodeAppendedImpulse");
var ConnectNodeSetImpulse_1 = require("./ConnectNodeSetImpulse");
var ConnectNodeKnowledge = /** @class */ (function (_super) {
    __extends(ConnectNodeKnowledge, _super);
    function ConnectNodeKnowledge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "ConnectNodeKnowledge";
        _this.append = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new ConnectNodeAppendedImpulse_1.ConnectNodeAppendedImpulse();
            config(entity);
            return "append(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.remove = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new ConnectNodeRemovedImpulse_1.ConnectNodeRemovedImpulse();
            config(entity);
            return "remove(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.set = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new ConnectNodeSetImpulse_1.ConnectNodeSetImpulse();
            config(entity);
            return "set(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.unset = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new ConnectNodeUnsetImpulse_1.ConnectNodeUnsetImpulse();
            config(entity);
            return "unset(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return ConnectNodeKnowledge;
}(Array));
exports.ConnectNodeKnowledge = ConnectNodeKnowledge;
//# sourceMappingURL=ConnectNodeKnowledge.js.map